module.exports = __webpack_public_path__ + "static/img/dg-asset.272438d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/20250724/ruanjian/dg-asset.svg
// module id = FkaT
// module chunks = 11